import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Overlay,
  Banner,
  Button,
  ToggleGroup,
  ToggleLabel,
  ToggleInput,
  PreferencesContainer,
  ButtonContainer,
} from "./CookieStyles";

function Cookie() {
  const [showBanner, setShowBanner] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);

  const [cookies, setCookies] = useState({
    essential: true,
    analytics: true,
    marketing: true,
  });

  // Get current route location
  const location = useLocation();

  useEffect(() => {
    // Check localStorage to see if cookies were accepted
    const savedCookies = JSON.parse(localStorage.getItem("cookies"));
    if (!savedCookies) {
      setShowBanner(true);
    } else {
      setCookies(savedCookies);
    }
  }, []);

  // Check if we are on the privacy page and handle banner visibility
  useEffect(() => {
    if (location.pathname === "/privacy") {
      setShowBanner(false); // Hide banner on privacy page
    } else {
      const savedCookies = JSON.parse(localStorage.getItem("cookies"));
      // If localStorage is empty, show banner on other pages as well
      if (!savedCookies) {
        setShowBanner(true);
      }
    }
  }, [location.pathname]);

  const handleAccept = () => {
    localStorage.setItem("cookies", JSON.stringify(cookies));
    setShowBanner(false);
  };

  const handleToggle = (type) => {
    setCookies((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  return (
    showBanner && (
      <Overlay>
        <Banner>
          {!showPreferences ? (
            <>
              <p>
                Wij gebruiken cookies om je ervaring op onze website te
                verbeteren. Sommige cookies zijn essentieel, terwijl andere ons
                helpen om statistieken te verzamelen of marketinginhoud op maat
                aan te bieden. Je kunt alle cookies accepteren of je voorkeuren
                beheren. Bekijk{" "}
                <Link to="/privacy" style={{ color: "#3393f0" }}>
                  hier
                </Link>{" "}
                onze Privacy en Cookie Policy.
              </p>

              <ButtonContainer>
                <Button onClick={handleAccept}>Alles accepteren</Button>
                <Button
                  onClick={() => setShowPreferences(true)}
                  style={{
                    backgroundColor: "white",
                    color: "#17224d",
                    border: "2px solid #17224d",
                  }}
                >
                  Beheer voorkeuren
                </Button>
              </ButtonContainer>
            </>
          ) : (
            <>
              <h3>Beheer je cookievoorkeuren</h3>
              <PreferencesContainer>
                <ToggleGroup>
                  <ToggleLabel>
                    Essentiele cookies (Altijd ingeschakeld)
                  </ToggleLabel>
                  <ToggleInput type="checkbox" checked disabled />
                </ToggleGroup>
                <ToggleGroup>
                  <ToggleLabel>Analytische cookies</ToggleLabel>
                  <ToggleInput
                    type="checkbox"
                    checked={cookies.analytics}
                    onChange={() => handleToggle("analytics")}
                  />
                </ToggleGroup>
                <ToggleGroup>
                  <ToggleLabel>Marketing cookies</ToggleLabel>
                  <ToggleInput
                    type="checkbox"
                    checked={cookies.marketing}
                    onChange={() => handleToggle("marketing")}
                  />
                </ToggleGroup>
              </PreferencesContainer>
              <ButtonContainer>
                <Button onClick={handleAccept}>Opslaan en accepteren</Button>
              </ButtonContainer>
            </>
          )}
        </Banner>
      </Overlay>
    )
  );
}

export default Cookie;
